/* tempexp_18086-start */
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { ReferralDisabledModalProps } from './ReferralDisabledModal';

export const renderReferralDisabledModal = ({ onClose, ...data }: ReferralDisabledModalProps) =>
    openPopupHelper({ popupName: popupNames.REFERRAL_DISABLED_MODAL, data, onClose });

export const closeReferralDisabledModal = () => closePopupHelper(popupNames.REFERRAL_DISABLED_MODAL);

/* tempexp_18086-end */
